/* eslint-disable */

// Style
import styles from "./taskView.module.css";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Divider from "@mui/material/Divider";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Button, ButtonGroup, IconButton, Stack, TextField, Tooltip, Typography, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemText } from "@mui/material";
import { Cancel, CancelOutlined, CheckCircleOutlineRounded, Clear, CloseRounded, DeleteOutline, Diversity2Rounded, Diversity3Rounded, DoDisturbRounded, ErrorRounded, KeyboardBackspaceRounded, NotificationImportantRounded, PersonAdd, PlayCircleOutlineRounded, QuestionAnswerRounded, RestartAltOutlined, RestartAltRounded, RotateLeftRounded, SendRounded, TaskAltRounded } from "@mui/icons-material";
import { blueGrey, green, grey, red } from "@mui/material/colors";
import MDBadge from "components/MDBadge";
import MDButton from "components/MDButton";
import { toast } from "react-toastify";

// Animacje GIF
import DoneAnimationGif from "assets/images/animations/Success.gif";
import CancelAnimationGif from "assets/images/animations/cancel.gif";
import StartWorkAnimationGif from "assets/images/animations/start-work.gif";

export default function TaskView() {

  const [task, setTask] = useState(null);
  const [handedTaskID, setHandedTaskID] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [newComment, setNewComment] = useState('');
  const [comments, setComments] = useState(null);
  const [numberOfComments, setNumberOfComments] = useState(0);

  // Stan widoczności dialogu
  const [open, setOpen] = useState(false);
  // Stan danych osób
  const [dialogPersons, setDialogPersons] = useState([]);
  // Stan wyszukiwanego tekstu
  const [searchText, setSearchText] = useState('');

  // Funkcja otwierająca dialog
  const handleOpenDialog = () => {
    setOpen(true);
  };

  // Funkcja zamykająca dialog
  const handleCloseDialog = () => {
    setOpen(false);
  };

  // Pobranie danych osób
  useEffect(() => {
    getAllPersonsForDialog();
  }, []);

  // Filtruj osoby na podstawie tekstu wyszukiwania
  const filteredDialogPersons = dialogPersons.filter(person => {
    const searchFileds = [
      `${person.first_name} ${person.last_name}`,
      person.department || ""
    ].join(" ").trim().toLowerCase();
    return searchFileds.includes(searchText.toLowerCase());
  });

  // Animacje
  const [showCloseAnimation, setShowCloseAnimation] = useState(false);
  const [showCancelAnimation, setShowCancelAnimation] = useState(false);
  const [showStartAnimation, setShowStartAnimation] = useState(false);

  //Dane
  const [attachedPersons, setAttachedPersons] = useState(null);

  // Funkcja do usuwania osoby
  const handleRemovePerson = async (userID) => {
    try {
      // Wywołanie API (zastąp URL rzeczywistym adresem API)
      const response = await fetch('https://devcolibri.pl/helpdesk-example/php/api/common-api.php/deleteUserToTask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          attach_user_id: userID,
          task_id: task.id
        }),
      });
      const data = await response.json();
      console.log(data);
      if(data.status === "success"){
        // setPersons((prevPersons) => prevPersons.filter(person => person.id !== userID));
        getAttachedPersonsToTask(task.id);
        toast.success(data.message);
      }
      if(data.status === "error"){
        toast.error(data.message);
      }      
    } catch (error) {
      console.error("Błąd podczas usuwania użytkownika: ", error);
      toast.error("Błąd podczas usuwania użytkownika: ", error);
    }
  };

  // Funkcja dodawania osoby
  const handleAddPerson = async (userID) => {
    try {
      // Wywołanie API (zastąp URL rzeczywistym adresem API)
      const response = await fetch('https://devcolibri.pl/helpdesk-example/php/api/common-api.php/addUserToTask', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          attach_user_id: userID,
          task_id: task.id
        }),
      });
      const data = await response.json();
      console.log(data);
      if(data.status === "success"){
        getAttachedPersonsToTask(task.id);
        handleCloseDialog();
        toast.success(data.message);
      }
      if(data.status === "error"){
        toast.error(data.message);
      }

      // Dodaj nową osobę do listy
      // setPersons((prevPersons) => [...prevPersons, newPerson]);
    } catch (error) {
      console.error("Błąd podczas dodawania użytkownika: ", error);
      toast.error("Błąd podczas dodawania użytkownika: ", error);
    }
  };

  // Pobieranie wszystkich uzytkowników
  const getAllPersonsForDialog = async () => {
    try {
      const response = await fetch('https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllUsers', {
        method: 'GET'
      });
      const listAllPerson = await response.json();

      // Dodaj nową osobę do listy
      // setPersons((prevPersons) => [...prevPersons, newPerson]);
      setDialogPersons(listAllPerson);
    } catch (error) {
      console.error("Błąd podczas dodawania osoby:", error);
      toast.error("Błąd podczas dodawania osoby:");
    }
  };

  // Pobieranie dołączonych uzytkowników
  const getAttachedPersonsToTask = async (taskId) => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAttachedPersonsToTask?id="+taskId);
      const data = await response.json();
      setAttachedPersons(data);
      console.log("Pobrany getAttachedPersonsToTask niżej");
      console.log(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera WorkersList: ", error);
      setAttachedPersons(null);
    }
  };

  //Funkcje
  const handleCommentChange = (event) => {
    setNewComment(event.target.value);
  };

  const getAllTaskComments = async (commentsTaskId) => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getAllTaskComments?id="+commentsTaskId);
      const data = await response.json();
      console.log(data);
      const reversedData = data.slice().reverse();
      setComments(reversedData);
      // return data;
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera:", error);
      setComments(null);
      // return [];
    }
  };
  
  const addNewTaskComment = async () => {

    if (newComment.trim() !== '') {

      try {
        const response = await fetch('https://devcolibri.pl/helpdesk-example/php/api/common-api.php/addNewTaskComment', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ 
            comment: newComment,
            task_id: task.id,
            performer: task.performer,
            assigned_performer_id: task.assigned_performer_id,
            created_by_user_id: task.created_by_user_id
          }),
        });
        const data = await response.json();
        
        if (response.ok) {
          setNewComment('');
          // toast.success(`Komentarz został wysłany`);
          toast.success(data.message);
          // console.log('Komentarz został wysłany');
          console.log("data.message");
          console.log(data.message);
          console.log("data");
          console.log(data);
          getAllTaskComments(handedTaskID);
        } else {
          // Obsłuż błąd, np. wyświetl komunikat o niepowodzeniu
          toast.error(`Wystąpił błąd podczas wykonywania żądania na serwerze: ${data}`);
          console.error(data);
        }
      } catch (error) {
        toast.error(`Wystąpił błąd podczas wykonywania żądania: ${error.message}`);
        console.error('Wystąpił błąd podczas wykonywania żądania:', error);
      }
    } else {
      toast.error("Pole komentarza jest puste");
      console.log('Pole komentarza jest puste');
    }
  };

  useEffect(()=>{
    location.state && location.state.taskID !== null && setHandedTaskID(location.state.taskID);
  },[location.state]);

  useEffect(()=>{
    if(handedTaskID !== null){
      console.log("handedTaskID: "+handedTaskID);
      getTask(handedTaskID);
      getAttachedPersonsToTask(handedTaskID);
      getAllTaskComments(handedTaskID);
    }
  },[handedTaskID]);

  useEffect(()=>{
    console.log("Comments is: ");
    console.log(comments);
    if (comments && comments.length !== 0) {
      setNumberOfComments(comments.length);
    }
  },[comments]);

  const getTask = async (taskIDToGet) => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/getTask?id="+taskIDToGet);
      const data = await response.json();
      setTask(data);
      console.log("Pobrany getTask niżej");
      console.log(data);
    } catch (error) {
      console.error("Błąd podczas pobierania danych z serwera WorkersList: ", error);
      setTask(null);
    }
  };

  const calculateTimeDifference = (creationTime) => {
    const creationDate = new Date(creationTime);
    const currentDate = new Date();
  
    // Oblicz różnicę czasu w milisekundach
    const timeDifference = currentDate - creationDate;
  
    // Oblicz liczbę dni, godzin i minut
    const days = Math.floor(timeDifference / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
  
    return `${days} dni i ${hours} godzin i ${minutes} minut`;
  };

  const handleReopenTask = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/reopenTaskById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          reopenTaskID: task.id
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response SUCCESS: ", data.message);
        getTask(task.id);
        toast.info(data.message);
        // handleUpdateTasksData();

        if(data.status === "success"){
          // Animacja
          setShowStartAnimation(true);
          setTimeout(() => {
            setShowStartAnimation(false);
          }, 3000);
        }

      } else {
        console.error("React Response NOT SUCCESS: ", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };

  const handleCancelTask = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/cancelTaskById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          cancelTaskID: task.id
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response SUCCESS: ", data.message);
        getTask(task.id);
        toast.info(data.message);
        // handleUpdateTasksData();

        if(data.status === "success"){
          // Animacja
          setShowCancelAnimation(true);
          setTimeout(() => {
            setShowCancelAnimation(false);
          }, 1800);
        }

      } else {
        console.error("React Response NOT SUCCESS: ", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };

  const handleCloseTask = async () => {
    try {
      const response = await fetch("https://devcolibri.pl/helpdesk-example/php/api/common-api.php/closeTaskById", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          closeTaskID: task.id
        }),
      });

      const data = await response.json();

      if (response.ok) {
        console.log("React Response SUCCESS: ", data.message);
        getTask(task.id);
        toast.info(data.message);
        // handleUpdateTasksData();

        if(data.status === "success"){
          // Animacja
          setShowCloseAnimation(true);
          setTimeout(() => {
            setShowCloseAnimation(false);
          }, 1800);
        }       

      } else {
        console.error("React Response NOT SUCCESS: ", data.message);
      }
    } catch (error) {
      console.error("Błąd podczas wysyłania żądania:", error);
    }
  };


  const handleKeyDown = (event) => {
    if (event.ctrlKey && event.key === 'Enter') {
      addNewTaskComment();
    }
  };

  const goToAllTasks = () => {
    navigate("/tasks");
  };


  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={4} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox mx={2} mt={-3} py={3} px={2} variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info">
                <MDTypography variant="h6" color="white">
                  <Tooltip title="Cofnij">
                    <IconButton aria-label="cofnij" sx={{ color: "#fff", "&:hover": { backgroundColor: "rgba(255, 255, 255, 0.2)" } }} onClick={goToAllTasks}>
                      <KeyboardBackspaceRounded fontSize="medium" sx={{ color: "#fff" }} />
                    </IconButton>
                  </Tooltip>
                  Otwarte zadanie (ID: {task !== null && (task.id)})
                </MDTypography>
              </MDBox>
              {
                task !== null ? (
                  <Grid container spacing={3} px={4} py={2}>

                    <Grid item xs={12}>
                      <Typography variant="h6">
                        ID zadania: {task.id}{" "}
                          {/* Status: 
                          <MDBadge badgeContent={task.status}
                            color={task.status === "nowe" ? "info" : 
                            task.status === "realizowane" ? "success" : 
                            task.status === "anulowane" ? "primary" : 
                            task.status === "zamknięte" ? "dark" : "light"} 
                            variant="gradient" size="sm" /> */}

                          {task.priority === "hight" ? 
                            <Tooltip title="Zadanie ma priorytet">
                              <ErrorRounded color="warning" style={{ marginLeft: '5px' }}/>
                            </Tooltip> 
                          : null}

                        <ButtonGroup variant="outlined" aria-label="Basic button group" sx={{ margin: 2}}>
                          <Button onClick={handleReopenTask} sx={{ color: 'success.main', borderColor: 'success.main', borderWidth: 2, 
                            '&:hover': { borderWidth: 2, backgroundColor: green[50], borderColor: 'success.main'} }} ><PlayCircleOutlineRounded />Realizuj</Button>
                          <Button onClick={handleCancelTask} sx={{ color: red[500], borderColor: red[500], borderWidth: 2, 
                            '&:hover': { borderWidth: 2, backgroundColor: red[50], borderColor: red[500] } }} ><CancelOutlined />Anuluj</Button>
                          <Button onClick={handleCloseTask} sx={{ color: blueGrey[900], borderColor: blueGrey[900], borderWidth: 2, 
                            '&:hover': { borderWidth: 2, backgroundColor: blueGrey[50],  borderColor: blueGrey[900] } }} ><CheckCircleOutlineRounded />Zamknij</Button>
                        </ButtonGroup>
                      </Typography>
                      <Typography variant="h6">
                        Status: 
                        <MDBadge badgeContent={task.status}
                            color={task.status === "nowe" ? "info" : 
                            task.status === "realizowane" ? "success" : 
                            task.status === "anulowane" ? "primary" : 
                            task.status === "zamknięte" ? "dark" : "light"} 
                            variant="gradient" size="sm" />
                      </Typography>
                    </Grid>

                    {/* Animacja Zakończone */}
                    {showCloseAnimation && (
                      <div className={styles.overlay}>
                        <img src={DoneAnimationGif} alt="Animacja" />
                      </div>
                    )}

                    {/* Animacja Anulowane */}
                    {showCancelAnimation && (
                      <div className={styles.overlay}>
                        <img src={CancelAnimationGif} alt="Animacja" />
                      </div>
                    )}

                    {/* Animacja Rozpoczęte */}
                    {showStartAnimation && (
                      <div className={styles.overlay}>
                        <img src={StartWorkAnimationGif} alt="Animacja" />
                      </div>
                    )}

                    <Grid item xs={12} sm={12} md={8} lg={8}>
                      <Card sx={{ padding: 2 }}>
                        <Typography variant="caption">
                          Tytuł
                        </Typography>
                        <Typography variant="h5">
                          {task.title}
                        </Typography>
                        <Divider/>
                        <Typography variant="caption">
                          Treść zadania
                        </Typography>
                        <Typography variant="subtitle2">
                          {task.content}
                        </Typography>
                        {/* <br /><br /> */}
                        {/* Załączone pliki: {task.selected_files === "" ? "nie wybrano" : task.selected_files} <br /> */}
                      </Card>

                      <Card sx={{ padding: 2, marginTop: 3}}>
                        <Typography>
                          Komentarze <QuestionAnswerRounded /> ({numberOfComments})
                        </Typography>
                        <br />
                        <TextField fullWidth multiline value={newComment} onChange={handleCommentChange}  label="Twoja wiadomość" rows={4} 
                          onKeyDown={handleKeyDown} // Obsługa zdarzenia klawiszy
                        />
                        <Tooltip title="ctrl + enter">
                          <MDButton endIcon={<SendRounded />} onClick={addNewTaskComment} variant="contained" color="info" fullWidth={false} size="small" style={{ width: 'auto', maxWidth: '200px', marginTop: 10 }} >
                            Dodaj wiadomość
                          </MDButton>
                        </Tooltip>
                        <br />
                        {comments && comments.length !== 0 && (
                          <>
                          {comments.map((commentFromMap)=>(
                            <>
                            <Typography variant="subtitle2">
                              {commentFromMap.first_name+" "+commentFromMap.last_name}
                              <MDBadge badgeContent={commentFromMap.created_at.slice(0,16)} color="light" variant="gradient" size="md"/>
                            </Typography>
                            <Typography variant="body1" fontWeight="" fontSize="17px">
                              {commentFromMap.comment}
                            </Typography>
                            <div style={{ marginBottom: '12px' }} />
                            </>
                          ))}
                          </>
                        )}
                      </Card>

                    </Grid>

                    
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                      <Card sx={{ padding: 2 }}>
                        <Typography variant="h6" gutterBottom>
                          Szczegóły
                        </Typography>  
                        <Divider />               
                        <Typography variant="subtitle2" fontSize="15px">
                          Utworzył
                        </Typography>
                        <Typography variant="body1" fontSize="16px" gutterBottom>
                          {task.created_by_first_name+" "+task.created_by_last_name+" ("}<Diversity2Rounded fontSize="small" />{" "+task.created_by_department+")"}
                        </Typography>  
                        <Typography variant="subtitle2" fontSize="15px">
                          Do kiedy trzeba wykonać
                        </Typography>
                        <Typography variant="body1" fontSize="16px" gutterBottom>
                          {task.time_to_do !== null ? task.time_to_do.slice(0,16) : "Czas nie jest wyznaczony" }
                        </Typography>                       
                        <Typography variant="subtitle2" fontSize="15px">
                          Od utworzenia
                        </Typography>
                        <Typography variant="body1" fontSize="16px" gutterBottom>
                          {calculateTimeDifference(task.creation_time)}
                        </Typography>
                        
                        {/* <Typography variant="subtitle2" fontSize="15px">
                          Aktualizacje
                        </Typography>
                        <Typography variant="body1" fontSize="16px" gutterBottom>
                          {task.new_info ? "Są nowe zmiany" : "Brak"}
                        </Typography> */}
                        
                        {/* Przydzielono: {task.performer === "worker" ? "pracownik" : "dział" }<br /> */}
                        <Typography variant="body1" fontSize="16px" gutterBottom>
                          Ilość komentarzy: {numberOfComments} <QuestionAnswerRounded />
                        </Typography>
                        <Divider />
                        <Typography variant="subtitle2" fontSize="15px">
                          Utworzono
                        </Typography>
                        <Typography variant="body1" fontSize="16px" gutterBottom>
                          {task.creation_time !== null ? task.creation_time.slice(0,16) : null}
                        </Typography>

                        {task.updated_at !== null && (
                          <>
                            <Typography variant="subtitle2" fontSize="15px">
                              Ostatnia zmiana statusu
                            </Typography>
                            <Typography variant="body1" fontSize="16px" gutterBottom>
                              {task.updated_at.slice(0, 16)}
                            </Typography>
                          </>
                        )}

                        {task.closed_at !== null && (
                          <>
                            <Typography variant="subtitle2" fontSize="15px">
                              Zamknięto
                            </Typography>
                            <Typography variant="body1" fontSize="16px" gutterBottom>
                              { task.closed_at.slice(0,16) }
                            </Typography>
                          </>
                        )}

                        {/* Dodaj osoby */}
                        <Typography variant="subtitle2" fontSize="15px" gutterBottom>Dołączone osoby</Typography>
                        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center" maxWidth="100%">  
                          {attachedPersons && attachedPersons.length > 0 && (
                              attachedPersons.map((person) => (
                                <Box
                                  key={person.id}
                                  display="flex"
                                  alignItems="center"
                                  bgcolor="#F0F3F8"
                                  p={1}
                                  borderRadius={3}
                                  sx={{
                                    height: "2rem",
                                    bgcolor: "#F0F3F8",
                                    transition: "background-color 0.3s ease", // Dodaje płynne przejście
                                    "&:hover": {
                                      bgcolor: "#DFE3E7" // Zmienia tło na ciemniejsze po najechaniu
                                    }
                                  }}
                                >
                                  <Typography variant="body2" color="#444746" fontWeight={500}>{person.first_name+" "+person.last_name}</Typography>
                                  <IconButton
                                    size="small"
                                    color="#444746"
                                    onClick={() => handleRemovePerson(person.user_id)}
                                  >
                                    <Clear />
                                  </IconButton>
                                </Box>
                          )))}

                          <Button variant="contained" color="primary" onClick={handleOpenDialog} size="small" sx={{ color: "#fff" }}>
                            Dodaj osobę
                          </Button>

                          <Dialog open={open} onClose={handleCloseDialog} fullWidth maxWidth="xs">
                            <DialogTitle>Kogo chcęsz dołączyć</DialogTitle>
                            <DialogContent>
                              <TextField label="Szukaj osoby lub dział" variant="outlined" fullWidth margin="normal" value={searchText} 
                              onChange={(e) => setSearchText(e.target.value)} />

                              <List>
                                {filteredDialogPersons.map((person) => (
                                  <ListItem key={person.user_id} button onClick={
                                      () => { console.log("Wybrano "+person.user_id); handleAddPerson(person.user_id) }}>
                                    <ListItemText primary={person.first_name+" "+person.last_name+" ("+person.department+")"} />
                                  </ListItem>
                                ))}
                              </List>
                            </DialogContent>
                          </Dialog>
                          
                        </Stack>

                      </Card>
                    </Grid>

                    {/* Komentarze na samym dole */}
                    {/* <Grid item xs={12}>
                      <Card sx={{ padding: 2 }}>
                        <Typography>
                          Komentarze <QuestionAnswerRounded /> ({numberOfComments})
                        </Typography>
                        <br />
                        <TextField fullWidth multiline value={newComment} onChange={handleCommentChange}  label="Twoja wiadomość" rows={4} 
                          onKeyDown={handleKeyDown} // Obsługa zdarzenia klawiszy
                        />
                        <Tooltip title="ctrl + enter">
                          <MDButton endIcon={<SendRounded />} onClick={addNewTaskComment} variant="contained" color="info" fullWidth={false} size="small" style={{ width: 'auto', maxWidth: '200px', marginTop: 10 }} >
                            Dodaj wiadomość
                          </MDButton>
                        </Tooltip>
                        <br />
                        {comments && comments.length !== 0 && (
                          <>
                          {comments.map((commentFromMap)=>(
                            <>
                            <Typography variant="subtitle2">
                              {commentFromMap.first_name+" "+commentFromMap.last_name}
                              <MDBadge badgeContent={commentFromMap.created_at.slice(0,16)} color="light" variant="gradient" size="md"/>
                            </Typography>
                            <Typography variant="body1" fontWeight="" fontSize="17px">
                              {commentFromMap.comment}
                            </Typography>
                            <div style={{ marginBottom: '12px' }} />
                            </>
                          ))}
                          </>
                        )}
                      </Card>
                    </Grid> */}

                  </Grid>
                ):
                (
                  <MDTypography variant="h6" color="dark" mx={2} textAlign="center">
                    <br/>
                    <NotificationImportantRounded /> Ups. Zadanie jeszcze nie jest wybrane.
                    <br/>
                    Wejdź w zakładkę <TaskAltRounded /> Zadania i otwórz swoje zadanie
                    <br/><br/>
                  </MDTypography>
                )
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}